import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import { FIELD_ALREADY_IN_USE_WARNING } from "../cells/constants";

export const FieldAlreadyInUseTooltipContent = () => {
    const { translate } = useTranslate();

    return (
        <Text
            fontVariant="body2"
            color={colorsPalettes.carbon[0]}
            data-automation="export-table-field-in-use-tooltip"
        >
            {translate(FIELD_ALREADY_IN_USE_WARNING)}
        </Text>
    );
};
